<template>
  <span class="status-badge" :class="`status-badge--${normalized}`">{{ status }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  status: string;
}>();

const normalized = computed(() => String(props.status || 'unknown').toLowerCase().replace(/\s+/g, '-'));
</script>

<style scoped>
.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
  background: var(--dx-color-border, #e0e0e0);
  color: var(--dx-color-text, #333);
}

.status-badge--active {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-badge--paused {
  background: #fff8e1;
  color: #f57f17;
}

.status-badge--disabled,
.status-badge--expired,
.status-badge--archived {
  background: #eceff1;
  color: #546e7a;
}
</style>
